import { listOrgEnrollments } from "./enrollmentHelpers"
import { listOrgOrders } from "./orderHelpers"

// Computes per-course stats (learners, completion, revenue) for the Courses
// list — same aggregation pattern as computeProgramPerformance, just scoped
// to individual courses instead of bundled course groups. Revenue is matched
// via order.productTitle since orders don't carry a courseId link yet.
export const computeCoursePerformance = async (orgId, courses) => {
  const [{ enrollments }, { orders }] = await Promise.all([
    listOrgEnrollments(orgId),
    listOrgOrders(orgId),
  ])

  const paidOrders = orders?.filter((o) => o?.status === "paid") || []
  const statsByCourseId = {}

  courses?.forEach((course) => {
    const courseEnrollments = enrollments?.filter((e) => e?.courseId === course?.courseId) || []
    const learnerIds = new Set(courseEnrollments?.map((e) => e?.userId))

    const avgCompletion = courseEnrollments?.length
      ? Math.round(
          courseEnrollments?.reduce((sum, e) => sum + (e?.progressPercent || 0), 0) / courseEnrollments.length
        )
      : 0

    const revenue =
      paidOrders?.filter((o) => o?.productTitle === course?.title)?.reduce((sum, o) => sum + (o?.amount || 0), 0) || 0

    statsByCourseId[course?.courseId] = {
      learners: learnerIds.size,
      completion: avgCompletion,
      revenue,
    }
  })

  return statsByCourseId
}